(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    (() => {
  const nav = document.getElementById('mobile-bottom-nav');
  if (!nav || nav.dataset.ready) return;
  nav.dataset.ready = 'true';
  const items = [...nav.querySelectorAll('.mbn__item')];
  items.forEach(item => {
    item.addEventListener('pointerdown', () => {
      item.classList.remove('mbn-tapped');
      requestAnimationFrame(() => item.classList.add('mbn-tapped'));
    });
    item.addEventListener('animationend', () => item.classList.remove('mbn-tapped'));
  });
  const shop = nav.querySelector('[data-mbn-menu]');
  const badge = nav.querySelector('#mbn-cart-count');
  const normalize = value => { try { return decodeURIComponent(value).replace(/\/$/, '') || '/'; } catch { return value; } };
  const path = normalize(location.pathname);
  items.forEach(item => {
    const current = !item.hasAttribute('data-mbn-menu') && normalize(new URL(item.href).pathname) === path;
    item.classList.toggle('is-active', current);
    if (current) item.setAttribute('aria-current', 'page');
  });
  const drawer = document.querySelector('[data-hydration-key="header-drawer-mobile"] header-drawer') || document.querySelector('header-drawer');
  const details = drawer?.querySelector('details');
  const summary = details?.querySelector('summary');
  if (details && summary) {
    shop.setAttribute('role', 'button');
    shop.setAttribute('aria-controls', details.id);
    shop.setAttribute('aria-expanded', String(details.open));
    let openedFromBar = false;
    shop.addEventListener('keydown', event => { if (event.key === ' ') { event.preventDefault(); shop.click(); } });
    shop.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (!customElements.get('header-drawer')) return;
      event.preventDefault();
      openedFromBar = true;
      if (!details.open) summary.click();
    });
    details.addEventListener('toggle', () => {
      shop.setAttribute('aria-expanded', String(details.open));
      if (!details.open && openedFromBar) {
        openedFromBar = false;
        shop.focus({ preventScroll: true });
      }
    });
  }
  function setCartCount(count) {
    if (!Number.isFinite(count)) return;
    const previous = Number(badge.dataset.count ?? badge.textContent);
    badge.dataset.count = String(count);
    if (count > previous) {
      badge.classList.remove('mbn-count-up');
      requestAnimationFrame(() => badge.classList.add('mbn-count-up'));
    }
    badge.textContent = count > 99 ? '99+' : String(count);
    badge.hidden = count === 0;
  }
  badge.addEventListener('animationend', () => badge.classList.remove('mbn-count-up'));
  let requestNumber = 0;
  async function refresh() {
    const request = ++requestNumber;
    try {
      const response = await fetch(nav.dataset.cartUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (request === requestNumber) setCartCount(cart.item_count);
    } catch {}
  }
  document.addEventListener('cart:update', event => {
    const count = event.detail?.resource?.item_count;
    if (Number.isFinite(count)) { requestNumber++; setCartCount(count); } else refresh();
  });
  document.addEventListener('cart:updated', refresh);
  window.addEventListener('pageshow', refresh);
  window.MobileBottomNav = { setCartCount, refresh };
  function syncKeyboard() {
    const typing = document.activeElement?.matches('input, textarea, [contenteditable="true"]');
    nav.toggleAttribute('data-keyboard-open', Boolean(typing && window.visualViewport && window.innerHeight - window.visualViewport.height > 150));
  }
  window.visualViewport?.addEventListener('resize', syncKeyboard);
  document.addEventListener('focusout', () => nav.removeAttribute('data-keyboard-open'));
})();
  } catch(e) { console.error(e); }
})();

})();
